import { render, staticRenderFns } from "./ListProductItem.vue?vue&type=template&id=9c4f4e6a&"
import script from "./ListProductItem.vue?vue&type=script&lang=js&"
export * from "./ListProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports